// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // :sm="6" :md="4" :lg="3" :xl="1"]

export default [
	{ label:'药品名称：',xs:6,sm:6,md:6,lg:8,xl:8,type:'select',modelValue:'drugName',prop:'',op:'nameOption'},
	{ label:'规格描述：',xs:6,sm:6,md:6,lg:8,xl:8,type:'input',modelValue:'drugSpec',prop:'',op:'selectOption'},
	{ label:'单价：', xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'purcPric',prop:'',placeholder:''},
	// { label:'',      xs:12,sm:12,md:2,lg:2,xl:2,type:'tag',modelValue:'pacUnt',prop:''},
	
	{ label:'生产厂家：',xs:6,sm:6,md:6,lg:8,xl:8,type:'select',modelValue:'prodentpName',prop:'',disabled:true},
	{ label:'数量：',    xs:6,sm:6,md:10,lg:10,xl:10,type:'inputNum',modelValue:'purcCnt',prop:''},
	// { label:'合同数量：',xs:6,sm:6,md:6,lg:4,xl:4,type:'input',modelValue:'cd',disabled:true},
	{ label:'上月销量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'ph',disabled:true},
	
	{ label:'上月采购数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'wh',prop:'',disabled:true},
	{ label:'同期采购数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cbdj',prop:'',disabled:true},
	{ label:'已购数量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'xdwcbdj',prop:'',disabled:true},
	{ label:'近期销量：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cbje',prop:'',disabled:true},

	{ label:'加入',xs:24,sm:24,md:24,lg:24,xl:24,type:'btn'},
]

